<template>
    <div class="mensagem pt-4 pb-4">
        <h3>Comentários</h3>

        <div class="row mt-4">
            <div class="col-3 col-sm-2  d-flex justify-content-center align-items-center">
                <img src="../assets/img/avatar.png" class="avatar" />
            </div>
            <div class="col-9 col-sm-10 ">
                <textarea rows="3" placeholder="Faça uma pergunta ou deixe o seu comentário" class="form-control" v-model="dsComentario"></textarea>
            </div>
        </div>
        <div class="row">
            <div class="col-3 col-sm-2 ">
            </div>
            <div class="col-9 col-sm-10 ">
                <button class="mt-4 float-end btn btn-blue txt-size-14 py-1" @click="enviarComentario(idUsuarioTreinamentoAula,null,dsComentario)">Enviar</button>
            </div>
        </div>

        <div v-for="(mensagem,index) in lstComentarios" :key="index">
            <hr />

            <div class="row mb-3">
                <div class="col-3 col-sm-2 d-flex justify-content-center align-items-center">
                    <img src="../assets/img/avatar.png" class="avatar" />               
                </div>
                <div class="col-9 col-sm-10 col-md-10 col-lg-10 col-xl-10">
                    <div class="row">
                        <div class="col-11">
                            <strong class="nmusuario d-block">{{ mensagem.nmUsuario }}</strong>
                            <span class="dtmensagem">{{ mensagem.dtMensagem }}</span>
                        </div>
                        <div class="col-1 txt-end">
                            <span class="txt-erro c-pointer" v-if="mensagem.dsLogin == user" @click="excluir(mensagem.idUsuarioTreinamentoAulaComentario)"><i class="fas fa-trash"></i></span>
                        </div>
                    </div>
                    <hr />
                    <p class="dsmensagem">{{ mensagem.dsMensagem }}</p>
                </div>
            </div>

            <div class="row mensagem-respostas" v-if="mensagem.respostas && mensagem.respostas.length > 0">     
                <div class="offset-sm-1 col-sm-11">
                    <div class="card">
                        <div class="card-content">
                            <div class="row">
                                <div v-for="(respostas, i) in mensagem.respostas" class="col-12" :key="i">
                                    <hr v-if="i > 0" />

                                    <div class="row">
                                        <div class="col-3 col-sm-2 d-flex justify-content-center align-items-center">
                                            <img src="../assets/img/avatar.png" class="avatar" />
                                        </div>
                                        <div class="col-9 col-sm-10 ">
                                            <div class="row">
                                                <div class="col-11">
                                                    <strong class="nmusuario d-block">{{ respostas.nmUsuario }}</strong>
                                                    <span class="dtmensagem">{{ respostas.dtMensagem }}</span>
                                                </div>
                                                <div class="col-1 txt-end">
                                                    <span class="txt-erro c-pointer" v-if="respostas.dsLogin == user" @click="excluir(respostas.idUsuarioTreinamentoAulaComentario)"><i class="fas fa-trash"></i></span>
                                                </div>
                                            </div>
                                            
                                            <hr />
                                            <p class="dsmensagem">{{ respostas.dsMensagem }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mt-4">                
                <div class="offset-sm-1 col-sm-11">
                    <textarea rows="3" placeholder="Deixe uma resposta para esse comentário" class="form-control" v-model="dsComentario2"></textarea>
                    <button class="mt-4 float-end btn btn-blue txt-size-14 py-1" @click="enviarComentario(idUsuarioTreinamentoAula,mensagem.idUsuarioTreinamentoAulaComentario,dsComentario2)">Responder</button>
                </div>                
            </div>
        </div>
    </div>
</template>

<script>
    import { urlApi, avisoErro, avisoSucesso } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'Comentarios',
        props: {
            idAula: {
                type: Number,
                required: true,
            },
            idUsuarioTreinamentoAula: {
                type: Number,
                required:true,
            },
            
        },
        computed: {
            user() {
                return this.$store.state.user.usuario.dsLogin
            },
        },
        data() {
            return {
                dsComentario: "",
                dsComentario2: "",

                lstComentarios: [],
            }
        },
        methods: {
            excluir(idUsuarioTreinamentoAulaComentario) {
                let $this = this;
                axios.delete(`${urlApi}/UsuarioTreinamentoAulaComentario/${idUsuarioTreinamentoAulaComentario}`)
                    .then(res => {
                        if (res.data.success) {
                            avisoSucesso("Comentário excluido com sucesso");
                            $this.getComentarios();
                        } else {
                            avisoErro("Não foi possível excluir comentário");
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível excluir comentário");
                    });
            },

            getComentarios() {
                let $this = this;
                axios.get(`${urlApi}/UsuarioTreinamentoAulaComentario/CarregarComentarios`, { params: { idAula: $this.idAula } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstComentarios = [];
                            if (res.data.data != null) {
                                $this.lstComentarios = res.data.data;
                            }
                        } else {
                            avisoErro("Não foi possível carregar os comentários");
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar os comentários");
                    });
            },

            enviarComentario(idUsuarioTreinamentoAula, idUsuarioTreinamentoAulaComentarioSuperior, dsComentario) {
                let $this = this;
                axios.post(`${urlApi}/UsuarioTreinamentoAulaComentario`, { idUsuarioTreinamentoAula: idUsuarioTreinamentoAula, idUsuarioTreinamentoAulaComentarioSuperior: idUsuarioTreinamentoAulaComentarioSuperior, dsComentario: dsComentario })
                    .then(res => {
                        if (res.data.success) {
                            avisoSucesso("Comentário registrado com sucesso");
                            $this.getComentarios();
                            $this.dsComentario = "";
                            $this.dsComentario2 = "";
                        } else {
                            avisoErro("Não foi possível enviar comentário");
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível enviar comentário");
                    });
            },

        },
        created: function () {
            this.getComentarios();
        },
        watch: {
            idAula: function () {
                this.getComentarios();
            },
        },
    }
</script>

<style lang="scss">
    .avatar {
        height: 90px;
        border-radius: 50%;
        border: 1px solid #8f8f8f;
    }

    .mensagem h3 {
        font-family: 'M PLUS Rounded 1c', sans-serif;
        color: #708796;
        font-size: 1.2rem;
    }

    .mensagem textarea {
        background: #f5f5f5;
    }

    .nmusuario { 
        color: #555555;
        font-weight: 600;
        font-size: 0.9rem;
    }

    .dtmensagem { 
        color: #555555;
        font-weight: 500;
        font-size: 0.7rem;
        font-style: italic;
    }

    .dsmensagem {
        color: #575757;
        font-size: 0.85rem;
        line-height: 140.62%;
        font-style: normal;
        font-weight: normal;
        text-align: justify;
        letter-spacing: -0.055em;
    }

    .mensagem-respostas .card-content {
        background: #f5f5f5;
        padding: 20px;
    }
</style>
